module.exports = __webpack_public_path__ + "4f2fa09e243dce4bdb11727fccd60f5f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/event.png
 ** module id = 1064
 ** module chunks = 0
 **/